module.exports = __webpack_public_path__ + "media/src/images/icons/document-a155349d28f7d6249cd58cc080e3b91d.svg";